import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NAccountViewCms } from './account-view-cms.component';

@Injectable({ providedIn: 'root' })
export class AccountViewCmsResolver implements Resolve<void | ICmsBlock<NAccountViewCms.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) {}
    resolve(): Promise<any> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NAccountViewCms.BLOCK_ID }, undefined);
    }
}
